export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/investor_pitch_fundraising.cc873a2.svg";